import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'vl-scroll-container',
  templateUrl: './scroll-container.component.html',
  styleUrls: ['./scroll-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ScrollContainerComponent {}
